import { create } from "zustand"
import type { DailyCalendarEvent } from "../entities/daily-calendar"

interface DailyCalendarEventsState {
  allEvents: DailyCalendarEvent[]
  filteredEvents: DailyCalendarEvent[]
  setAllEvents: (allEvents: DailyCalendarEvent[]) => void
  setFilteredEvents: (filteredEvents: DailyCalendarEvent[]) => void
}

export const useDailyCalendarEvents = create<DailyCalendarEventsState>((set) => ({
  allEvents: [],
  filteredEvents: [],
  setAllEvents: (allEvents) => set(() => ({ allEvents })),
  setFilteredEvents: (filteredEvents) => set(() => ({ filteredEvents })),
}))

export default useDailyCalendarEvents.getState()
